import { portalAPI } from 'store/api/portalAPI';
import type { FigureDefinition, FigureRows } from 'types/aiChatFigure';

/** The rows of an AI answer's Figure, read again for the viewer from the Figure's source. */
export const aiChatFigureApi = portalAPI.injectEndpoints({
    endpoints: (builder) => ({
        // Keyed by the definition, so a Figure shown twice is read once while its chat is open.
        readAiChatFigureRows: builder.query<FigureRows, FigureDefinition>({
            query: (definition) => ({ url: '/v1/ai/chat/figures', method: 'POST', body: definition }),
            // A read sent as a POST: it must not hold, nor release, the lock a write puts on the submit buttons.
            extraOptions: { skipButtonDisable: true },
            // Dropped once no chat shows it: a reopened chat reads its Figures as they are today.
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useReadAiChatFigureRowsQuery } = aiChatFigureApi;
